<template lang="pug">
.upload-video
  Button(:class="`${showForm ? 'disable' : ''}`" :disabled="disableUploadVideo" @click="toggleForm(true)")
    span.mobile {{ $t('video.upload_video_short') }}
    span.desktop {{ $t('video.upload_video') }}
  card-minimal(v-if="showForm").upload-form
    div(slot="secondgroup").ml-a
      .tooltip.bottom-right
        i.mdi.mdi-help-circle
        .tooltiptext: ul: li(v-for="(criteria, index) in $t('fileupload.video_criteria')", :key="index") {{ criteria }}
    .p-t-2.p-l-2
      card-minimal-title(title="Upload video")
    .p-a-0.fd-c
      .upload
        Fileupload(@data="fileData", :noText="false", :validFormats="['video/', 'text/plain']", :maxSize=6000000, :largeFile="true", ref="videoRef", :state="state").full
        .uploading-started(v-if="state === 'uploadingStarted'")
          span.mobile {{ $t('video.uploading_text_mobile') }}
          span.desktop {{ $t('video.uploading_text_desktop') }}
        .upload-text {{ $t('fileupload.click_or_drag_video') }}
      .d-f.jc-fe.m-t-2.p-x-4.p-t-2.p-b-4
        div
          ul: li(v-for="(criteria, index) in $t('fileupload.video_criteria')", :key="index")
            small {{ criteria }}
        .ml-a
          Button.outline(@click="toggleForm(false)") {{$t('common.close')}}
</template>

<script>

import Fileupload from '@/components/file-upload.vue';

export default {
  props: {
    showForm: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Fileupload,
  },
  computed: {
    disableUploadVideo() {
      const trialEnded = this.$store.getters['AccountManager/trialEnded'];
      const subscriptionEnded = this.$store.getters['AccountManager/subscriptionEnded'];

      if (trialEnded || subscriptionEnded) {
        return true;
      }

      return false;
    },
  },
  methods: {
    toggleForm(bool) {
      if (this.disableUploadVideo) {
        return;
      }

      this.$emit(bool ? 'open' : 'cancel');
    },
    fileData(file) {
      this.state = 'uploadingStarted';
      this.$root.$emit('fileUpload', file);
      this.$refs.videoRef.reset();

      this.stateTimeout = setTimeout(() => {
        this.state = '';
      }, 5000);
    },
  },
  data() {
    return {
      state: '',
      stateTimeout: null,
    };
  },
  beforeDestroy() {
    clearTimeout(this.stateTimeout);
  },
};
</script>

<style lang="sass" scoped>

span.mobile
  display: block
  @media (min-width: 600px)
    display: none
span.desktop
  display: none
  @media (min-width: 600px)
    display: block

.upload-video
  position: relative
  .tooltip
    i
      font-size: 1.5rem
      color: #35acdc
    .tooltiptext
      line-height: 1.8
.upload
  background-color: #f5f7f8
  background-size: cover
  background-position: 50% 50%
  border-bottom: 1px solid #eceef0
  display: flex
  flex-direction: column
  padding: 20px
  position: relative
  width: 100%
  .file-upload
    padding: 2rem
  .tooltip
    color: white
    margin-right: .5rem
    position: absolute
    left: 1rem
    bottom: .8rem
    i
      color: white
      font-size: 1.25rem
    .tooltiptext
      padding: .5rem
      ul
        list-style: none
        margin: 0
        padding: 0
.uploading-started
  color: green
  line-height: 1rem
  font-weight: bold
  font-size: 12px
  text-align: center
  margin-top: 1rem
.upload-text
  text-align: center
  line-height: 1rem
  margin-top: 1rem
  font-size: 12px
.upload-form
  position: absolute
  top: 54px
  right: 0px
  z-index: 3
  width: 365px
  max-width: calc(100vw - 40px)
</style>
